import React from 'react';

import {usePublicEventsQuery} from '@/api';

import {EventCard} from '../components/EventCard';

export const EventListPage: React.FC = () => {
  const {data, loading} = usePublicEventsQuery();

  return (
    <main className="mx-auto max-w-screen-xl px-4 py-8">
      <h1 className="mb-6 text-2xl font-light md:text-3xl">イベント一覧</h1>
      {loading && <p className="text-gray-500">読み込み中...</p>}
      {!loading && data?.publicEvents?.length === 0 && (
        <p className="text-gray-500">現在開催予定のイベントはありません。</p>
      )}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {data?.publicEvents?.map(
          (event) => event && <EventCard key={event.id} event={event} />,
        )}
      </div>
    </main>
  );
};
